import React from 'react';
import {
  Box,
  Skeleton,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

const TrafficChart = ({ data, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (loading) {
    return (
      <Box sx={{ height: 250, mt: 1 }}>
        <Skeleton variant="rectangular" height={250} />
      </Box>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Box sx={{ 
        height: 250, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 1
      }}>
        <Typography variant="body2" color="text.secondary">
          No traffic data available
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: 250, mt: 1 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{
            top: 10,
            right: isMobile ? 10 : 30,
            left: isMobile ? 0 : 20,
            bottom: isMobile ? 20 : 30,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: isMobile ? 10 : 12 }}
            angle={isMobile ? -45 : 0}
            textAnchor={isMobile ? "end" : "middle"}
            height={isMobile ? 60 : 40}
            interval={isMobile ? "preserveStartEnd" : 0}
          />
          <YAxis 
            tick={{ fontSize: isMobile ? 10 : 12 }}
            width={isMobile ? 30 : 40}
          />
          <Tooltip />
          <Legend 
            wrapperStyle={{
              fontSize: isMobile ? 10 : 12,
              paddingTop: 10
            }}
          />
          <Line 
            type="monotone" 
            dataKey="searches" 
            stroke="#8884d8" 
            strokeWidth={2}
            dot={{ fill: '#8884d8', strokeWidth: 2, r: isMobile ? 2 : 3 }}
            activeDot={{ r: isMobile ? 4 : 6 }}
            name="Searches"
          />
          <Line 
            type="monotone" 
            dataKey="registrations" 
            stroke="#82ca9d" 
            strokeWidth={2}
            dot={{ fill: '#82ca9d', strokeWidth: 2, r: isMobile ? 2 : 3 }}
            activeDot={{ r: isMobile ? 4 : 6 }}
            name="Registrations"
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default TrafficChart;